import React from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useLocation } from "react-router-dom";

const Footer: React.FC = () => {
    const location = useLocation();

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const isBgShow = (["/dashboard", "/", '/tools']).includes(location.pathname);

    return (
        <Box
            component="footer"
            sx={{
                position: "fixed",
                bottom: 0,
                left: 0,
                right: 0,
                height: "32px",

                // LIGHT MODE (unchanged)
                backgroundColor: isBgShow ? 'transparent' : 'white',
                borderTop: "1px solid rgba(0, 0, 0, 0.12)",

                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",

                px: isMobile ? 1 : 3,
                zIndex: 1000,

                // 🌙 DARK MODE
                '@media (prefers-color-scheme: dark)': {
                    backgroundColor: isBgShow ? 'transparent' : '#020617',
                    borderTop: '1px solid rgba(255,255,255,0.1)',
                },
            }}
            className="custom-footer"
        >
            <Typography
                variant="body2"
                sx={{
                    mr: 0.5,
                    color: "text.secondary",

                    '@media (prefers-color-scheme: dark)': {
                        color: '#94a3b8',
                    }
                }}
            >
                Powered by
            </Typography>

            <img
                src="/icons/WinWire.svg"
                alt="WinWire"
                style={{
                    height: isMobile ? "16px" : "20px",
                    width: isMobile ? "50px" : "60px",
                    objectFit: "contain"
                }}
            />
        </Box>
    );
};

export default Footer;